// extracted by mini-css-extract-plugin
export default {"recos":"v1-z","productCardOverride":"w1-z","rowHasBadge":"x1-z"};